'use strict';

const jQuery = require('jquery');
const Translator = require('./../../../core/translator');

const Zone = require('./../../../services/structure/zone');
const Tpl = require('./../templates/knowledge_graph.hbs');
const KnowledgeGraphRepository = require('./../repository/knowledgeGraphRepository');
const UserPreferenceRepository = require('./../../../bundles/content/repository/UserPreferenceRepository');
const FormBuilder = require('../../../services/form');
const translator = require('../../../core/translator');
const Notifier = require('../../../services/notifier');

const editableFields = ['organization', 'website_name', 'website_description', 'organization_social_profiles'];

/**
 * Handle on menu click.
 */
module.exports.onMenuClick = function() {
  let $container = jQuery(Tpl());

  KnowledgeGraphRepository.getParameters().done(function(params) {
    let graphParams = params['graph'] || [];
    buildForm($container, graphParams, editableFields);
  });

  Zone.addLayer(Translator.translate('knowledge_graph'), `<p>${Translator.translate('knowledge_graph_description')}</p>`);
  Zone.setFullPanel(Translator.translate('knowledge_graph_full_panel'), $container);
};

/**
 * Build form.
 * @param {object} $container
 * @param {Array} graphParams
 * @param {Array} editableFields
 */
const buildForm = function($container, graphParams, editableFields) {
  let $graphList = $container.find('div.graph-list-group');
  let formConfig = {
    'elements': {},
    'form': {
      'submit_label': Translator.translate('save'),
    },
  };

  Object.entries(graphParams).forEach((param) => {
    const [key, value] = param;

    formConfig.elements[key] = {
      'type': key === 'organization_social_profiles' ? 'textList' : 'text',
      'label': translator.translate('knowledge_graph_graph_' + key),
      'value': value,
      'disabled': !editableFields.includes(key),
      'wrap_class': 'mt-2 mb-2' + (isSocialProfilesField ? ' cloud-kn-social-profiles' : ''),
    };
  });

  let form = FormBuilder.getForm(formConfig);

  form.on('submit', onSubmit);

  $graphList.append(form.render());
};

/**
 * Handle on submit.
 * @param {object} values Values form.
 */
const onSubmit = function(values) {
  let entries = {};

  Object.entries(values).forEach((data) => {
    const [key, value] = data;
    if (editableFields.includes(key)) {
      entries[key] = value;
    }
  });

  UserPreferenceRepository.save('knowledge-graph', entries).catch(function() {
    Notifier.error(Translator.translate('an_error_occured'));
  });

  Notifier.success(Translator.translate('recorded'));
};

/**
 * Check if the parameter is the social profiles field.
 * @param {string} key Parameter name.
 * @returns {boolean} True or False
 */
const isSocialProfilesField = function(key) {
  return key === 'organization_social_profiles';
};

